module.exports = __webpack_public_path__ + "static/media/mv07.130f901a.jpg";